<template>
	<router-view></router-view>
</template>

<script lang="ts" setup>
	
</script>

<style scoped lang="scss">
	
</style>